// eslint-disable-next-line
import React, { PureComponent, ReactNode } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button, { ButtonProps } from '@material-ui/core/Button';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Box } from '@material-ui/core';

export type Props = {
  children?: ReactNode;
  open: boolean;
  title: string;
  onOk: any;
  onCancel?: any;
  okLabel?: string;
  okButtonProps?: ButtonProps;
  noOkBtn?: boolean;
  cancelLabel?: string;
  actions?: ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
};
class Modal extends PureComponent<Props> {
  renderChildren = (children: ReactNode) => {
    if (typeof children === 'string') {
      return <DialogContentText>{children}</DialogContentText>;
    }
    return children;
  };

  render() {
    const {
      children,
      open,
      title,
      onOk,
      onCancel,
      okLabel,
      cancelLabel,
      actions,
      noOkBtn,
      maxWidth = 'xs',
      okButtonProps,
    } = this.props;
    return (
      <Dialog
        data-testid="modal"
        open={open}
        onBackdropClick={onCancel}
        onEscapeKeyDown={onCancel}
        maxWidth={maxWidth}
        fullWidth
      >
        <Box mt={3}>
          <DialogTitle data-testid="modal-title">{title}</DialogTitle>
        </Box>
        <DialogContent data-testid="modal-content">
          {this.renderChildren(children)}
        </DialogContent>
        <Box mt={1} mx={3} mb={2}>
          <DialogActions>
            {actions || (
              <>
                {onCancel && (
                  <Button onClick={onCancel} data-testid="modal-cancel-btn">
                    {cancelLabel || 'CANCELAR'}
                  </Button>
                )}
                {!noOkBtn && (
                  <Button
                    disabled={!open}
                    color="primary"
                    onClick={onOk}
                    data-testid="modal-confirm-btn"
                    {...okButtonProps}
                  >
                    {okLabel || 'CONFIRMAR'}
                  </Button>
                )}
              </>
            )}
          </DialogActions>
        </Box>
      </Dialog>
    );
  }
}
export default Modal;
